import { useMutation } from "@tanstack/react-query";
import { gqlReqNext } from "~utils/api/gql-req/next";

import {
	SubmitContactFormMutation,
	SubmitContactFormMutationVariables,
} from "~landing/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	mutation SubmitContactForm(
		$input: SubmitContactFormInput!
		$recaptchaToken: String!
	) {
		submitContactForm(input: $input, recaptchaToken: $recaptchaToken)
	}
`;

export const useSubmitContactForm = () => {
	return useMutation({
		mutationKey: ["submitContactForm"],
		mutationFn: (variables: SubmitContactFormMutationVariables) =>
			gqlReqNext<SubmitContactFormMutation, SubmitContactFormMutationVariables>(
				{
					query,
					variables,
					authMode: "iam",
				},
			),
	});
};
